import React from 'react'
import { LaTercera } from '@labcon/copesa-logos'
import { Link } from 'gatsby'
import styled from 'styled-components'
import logoInvestigacionWhite from '@/images/logo-investigacion-white.svg'

const StyledHeader = styled.header`
  backdrop-filter: saturate(300%) blur(5px);
  background-color: rgba(0, 0, 0, 0.9);
`

const Header = () => (
  <>
    <StyledHeader className="fixed top-0 left-0 right-0 z-20 border-gray-300 border-solid shadow-md">
      <div className="grid items-center h-16 grid-cols-12 px-4 mx-auto sm:px-4 lg:px-4">
        <div className="col-span-3 ">
          <a
            href="https://www.latercera.com/canal/investigacion-y-datos/?utm_medium=mapa-violencia&utm_medium=interactivo"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:block">
            <img
              className="h-8"
              src={logoInvestigacionWhite}
              alt="Investigación y Datos - La Tercera"
            />
          </a>
        </div>
        <div className="flex justify-center col-span-6">
          <a
            href="https://www.latercera.com/canal/investigacion-y-datos/?utm_medium=mapa-violencia&utm_medium=interactivo"
            target="_blank"
            rel="noopener noreferrer"
            className="sm:hidden">
            <img
              className="h-8"
              src={logoInvestigacionWhite}
              alt="Investigación y Datos - La Tercera"
            />
          </a>
        </div>
        <div className="flex justify-end col-span-3">
          <a
            className="hidden sm:block"
            href="https://www.latercera.com/?utm_medium=mapa-violencia&utm_medium=interactivo"
            target="_blank"
            rel="noopener noreferrer"
            title="La Tercera">
            <LaTercera width="200" height="20" schema="light" />
          </a>
        </div>
      </div>
    </StyledHeader>
  </>
)

export default Header
